import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { PlusOutlined, SearchOutlined, FilterFilled, FilterOutlined, CloseOutlined } from '@ant-design/icons';
import { Button, Modal, Tooltip, Input, Col, Row } from 'antd';
import PropTypes from 'prop-types';
const { Search } = Input;
const confirm = Modal.confirm;


class TableActionBar extends Component {

    static propTypes = {
        showSearch: PropTypes.bool,
        onSearch: PropTypes.func,
        searchOpition: PropTypes.object,
        showFilter: PropTypes.bool,
        showActionButton: PropTypes.bool,
        disabled: PropTypes.bool,
        isloading_delete: PropTypes.bool,
        filters: PropTypes.array,
        filterColSpan: PropTypes.number,
        placeholderSearch: PropTypes.string,
        activeFilter: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.number,
            PropTypes.string
        ]),
        addText: PropTypes.string
    }

    static defaultProps = {
        onSearch: () => { },
        showSearch: true,
        searchOpition: {},
        isShowPublishButtons: true,
        isShowAddButton: true,
        isShowDeleteButton: true,
        showFilter: true,
        showActionButton: true,
        disabled: false,
        isloading_delete: false,
        filters: [],
        filterColSpan: 4,
        activeFilter: false,
        defaultKeyword: '',
        addText: 'Thêm mới',
        disabledAddBtn: false,
        placeholderSearch: 'Tìm kiếm.....'
    }

    state = {
        activeFilter: this.props.activeFilter
    }

    onOpenFilter() {
        this.setState({
            activeFilter: !this.state.activeFilter
        })
    }

    openAlert() {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá những bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.onDelete(),
            onCancel: () => { },
        })
    }

    onClearFilter() {
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: ''
        });
        this.setState({ activeFilter: false })
    }

    render() {
        const { placeholderSearch, showFilter, searchOpition, showSearch, isShowAddButton, disabledAddBtn, isShowDeleteButton, showActionButton, disabled, isloading_delete, filters, filterColSpan, defaultKeyword } = this.props;
        var { activeFilter } = this.state;

        return (
            <div style={{ margin: "10px 0 5px 0" }} >
                <Row type="flex" align="top" className='TableActionBar'>
                    {
                        showActionButton ?
                            <Col sm={{ span: 18 }} xs={{ span: 24 }} >
                                {
                                    isShowAddButton ? (
                                        <Button disabled={disabledAddBtn} className="table-button" htmlType="submit" type="primary" onClick={() => this.props.onAdd()} icon={<PlusOutlined />} >
                                            {this.props.addText}
                                        </Button>
                                    ) : null
                                }
                                {
                                    isShowDeleteButton ? (
                                        <Button loading={isloading_delete} className="table-button" type="danger" onClick={() => this.openAlert()} disabled={disabled} >
                                            Xoá
                                        </Button>
                                    ) : null
                                }
                                {this.props.children}
                            </Col>
                            : <Col sm={{ span: 18 }} xs={{ span: 24 }} ></Col>
                    }

                    <Col sm={{ span: 6 }} xs={{ span: 24 }} style={{ display: 'flex' }} >
                        {
                            showSearch ?
                                <Search
                                    name="keyword"
                                    className="txtSearch"
                                    placeholder={placeholderSearch}
                                    onSearch={value => this.props.onSearch(value)}
                                    enterButton={<SearchOutlined />}
                                    style={{ width: '100%' }}
                                    defaultValue={defaultKeyword}
                                    allowClear
                                    {...searchOpition}
                                />
                                : null
                        }
                        {
                            showFilter ?
                                <Tooltip title="Filter">
                                    <div onClick={() => this.onOpenFilter()}>
                                        {
                                            activeFilter ? <FilterFilled className="filter-icon" style={{ color: "#3498db" }} /> : <FilterOutlined className="filter-icon" />
                                        }
                                    </div>
                                </Tooltip>
                                : null
                        }
                    </Col>
                </Row>
                {
                    activeFilter ? (
                        <div className="mt-2">
                            <Row gutter={16}>
                                {
                                    filters.filter(Boolean).map((filter, index) => <Col className='mb-2' xs={24} md={filterColSpan}>{filter}</Col>)
                                }
                                <Col className='mb-2' xs={24} md={4}>
                                    <Button shape="round" icon={<CloseOutlined />} className="clear-button" onClick={() => this.onClearFilter()}>Xoá bộ lọc</Button>
                                </Col>
                            </Row>
                        </div>
                    ) : null
                }
            </div>
        );
    }
}


export default withRouter(TableActionBar);